import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region TRACKING NUMBER

function _TrackingNumber(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.TrackingNumber);
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const TrackingNumber = withLabelTokenParsing(_TrackingNumber, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.TrackingNumber:
            if (!Utilities.isNullOrWhitespace(data.TrackingNumber)) {
                replaceString = data.TrackingNumber;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => [{ display: 'Tracking Number', token: Token.TrackingNumber }];
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Tracking Number:'})),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.TrackingNumber}}`, token: Token.TrackingNumber }))
    }
};

// #endregion TRACKING NUMBER

export {
    TrackingNumber as Component,
    Tokens,
    TypeConfig
}